// export const API_BASE   = "http://172.16.11.135:19032/api/admin";
// export const IMAGE_BASE = 'http://172.16.11.135:19032/';

export const API_BASE   = "https://lotteria-api.devtechnosys.tech/api/admin";
export const IMAGE_BASE = 'https://lotteria-api.devtechnosys.tech/';

export const BASE_API = API_BASE + "/admin";
export const MAIN_URL = BASE_API + "/api/admin";
export const MOBILE_REGEX = /^[0-9]{10}$/;

// export const PASSWORDS_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%^&*?])[A-Za-z\d#$@!%^&*?]{8,}$/;
// export const PASSWORDS_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]{8,}$/;
export const PASSWORDS_REGEX = /^(?=\S{8,})(?=\S)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\p{L}\p{N}\s]).*$/u;

export const EMAIL_REGEX =  /^(?![.+-])([a-zA-Z0-9._+-]+)(?!\.)[a-zA-Z0-9]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
export const NOSPACE_REGEX = /^[^\s](?:.*[^\s])?$/;

export const REMOVENBSP = /&nbsp;/g

export const NOSPACE = "This field can't start or end with spaces.";

export const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "video/mp4",
  "video/x-ms-wmv",
  "video/quicktime",
  "video/webm",
  "application/pdf",
  "text/plain",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const MULTIPLESPACE = /  +/g;

export const CARD_REGEX = /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/g;

export const NODIGITREGEX = /^([^0-9]*)$/;

export const DECIMALPATTERN = /^[0-9]+(\.[0-9]{1,2})?$/;

export const REMOVEHTML = /(<([^>]+)>)/gi;

export const URL_REGEX = /^(https?:\/\/)?([^\s:@]+:[^\s:@]*@)?((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|localhost|(\d{1,3}\.){3}\d{1,3})(:\d+)?(\/[^\s]*)?$/;

export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const STATUS_OPTIONS = [
  { value: false, label: "Active" },
  { value: true, label: "Inactive" },
];

export const STATUS_OPTIONS_LIST = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

export const Verification_OPTIONS = [
  { value: "completed", label: "Completed" },
  { value: "pending", label: "Pending" },
  { value: "cancelled", label: "Cancelled" },
];

export const TRANGATIONTYPE_TYPE = [
  { value: "credit", label: "Credit" },
  { value: "debit", label: "Debit" },
  { value: "winning-price", label: "Winning Price" },
  { value: "paid-for-lottery", label: "Paid For Lottery" },
  
];

export const PLAN_OPTIONS = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];